// ThemeWrapper.tsx
import React, { ReactNode } from 'react';
import { useDashboard } from './context/DashboardContext';

interface ThemeWrapperProps {
  children: ReactNode;
}

export const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
  const { theme } = useDashboard();
  
  // Apply theme classes to the entire dashboard
  React.useEffect(() => {
    // Remove existing theme classes
    document.documentElement.classList.remove('dark', 'light');
    // Add current theme class
    document.documentElement.classList.add(theme);
    
    // Add body class for better theme targeting
    document.body.classList.remove('dark', 'light');
    document.body.classList.add(theme);
    
    // Set CSS variables for theme colors
    if (theme === 'light') {
      // Luxury light theme colors
      document.documentElement.style.setProperty('--bg-primary', '#ffffff');
      document.documentElement.style.setProperty('--bg-secondary', '#fafafa');
      document.documentElement.style.setProperty('--bg-tertiary', '#f5f5f5');
      document.documentElement.style.setProperty('--text-primary', '#0a0a0a');
      document.documentElement.style.setProperty('--text-secondary', '#525252');
      document.documentElement.style.setProperty('--text-tertiary', '#737373');
      document.documentElement.style.setProperty('--border-primary', '#e5e5e5');
      document.documentElement.style.setProperty('--border-secondary', '#d4d4d4');
      document.documentElement.style.setProperty('--accent', '#0066cc');
    } else {
      // Keep dark theme as is
      document.documentElement.style.setProperty('--bg-primary', '#111827');
      document.documentElement.style.setProperty('--bg-secondary', '#1f2937');
      document.documentElement.style.setProperty('--bg-tertiary', '#374151');
      document.documentElement.style.setProperty('--text-primary', '#f9fafb');
      document.documentElement.style.setProperty('--text-secondary', '#d1d5db');
      document.documentElement.style.setProperty('--text-tertiary', '#9ca3af');
      document.documentElement.style.setProperty('--border-primary', '#374151');
      document.documentElement.style.setProperty('--border-secondary', '#4b5563');
      document.documentElement.style.setProperty('--accent', '#3b82f6');
    }
  }, [theme]);
  
  return <>{children}</>;
};